<div class="bg-white pb-2">
    <router-outlet></router-outlet>
</div>
